<div class="grid">
    <div class="mb-4 w-1/2 mx-auto text-center">
        <p-selectButton class="w-full" [options]="pageOptions" (ngModelChange)="selecionarOpcao($event.value)"
            [(ngModel)]="pageConfigs" optionLabel="name">
            <ng-template let-option pTemplate="item">
                <div class="flex align-items-center justify-content-center w-full">
                    <i [ngClass]="option.icon" class="mr-2"></i>
                    <span class="font-bold">{{ option.name }}</span>
                </div>
            </ng-template>
        </p-selectButton>
    </div>
</div>
<div class="grid ss-l-marginProfileConfig" *ngIf="activeOption == 1">
    <div class="col-12 xl:col-6">
        <div class="card">
            <div class="flex align-items-center justify-content-between mb-2">
                <span class="text-900 text-xl font-semibold">
                    Informações do usuário
                </span>
            </div>
            <div>
                Mantenha seus dados atualizados.
            </div>
            <div class="col-12 mb-4 mt-4 p-0">
                <label class="w-full ss-g-globalClassLabel">
                    Nome
                    <div class="p-inputgroup mt-2">
                        <input type="text" id="title" pInputText class="w-full" [(ngModel)]="user_name"
                            (ngModelChange)="checkInput1()">
                    </div>
                </label>
                <div class="flex align-items-center justify-content-between mt-2">
                    <!-- Mensagem de Erro à esquerda -->
                    <small *ngIf="errorName" class="p-error">
                        O nome não pode estar vazio
                    </small>
                </div>
            </div>

            <div class="col-12 mb-4 mt-4 p-0">
                <label class="w-full ss-g-globalClassLabel">
                    Sobrenome
                    <div class="p-inputgroup mt-2">
                        <input type="text" id="title" (ngModelChange)="checkInput2()" pInputText class="w-full"
                            [(ngModel)]="user_sobrenome">
                    </div>
                </label>
            </div>
            <div class="col-12 mb-4 mt-4 p-0">
                <label class="w-full ss-g-globalClassLabel">
                    Nome que aparecerá no chat
                    <div class="p-inputgroup mt-2">
                        <input type="text" id="title" (ngModelChange)="checkInput3()" pInputText class="w-full"
                            [(ngModel)]="chat_name">
                    </div>
                </label>
            </div>
            <div class="col-12 mb-4 mt-4 p-0">
                <label class="w-full ss-g-globalClassLabel">
                    Email
                    <div class="p-inputgroup mt-2">
                        <input type="text" pInputText class="w-full" [(ngModel)]="email"
                            (ngModelChange)="checkInputEMail()" disabled>
                        <span class="p-inputgroup-addon" style="padding: 0;">
                            <button pButton type="button" icon="pi pi-pencil" (click)="openDialogEmail()"
                                class="p-button-outlined border-none"></button>
                        </span>
                    </div>
                </label>
                <div class="flex align-items-center justify-content-between mt-2">
                    <!-- Mensagem de Erro à esquerda -->
                    <!-- <small *ngIf="errorEmail" class="p-error">
                        O email não pode estar vazio
                    </small> -->
                </div>
            </div>

            <span class="ss-g-globalClassLabel flex-start" style="align-self:flex-start">Adicione uma foto ao seu
                perfil</span>
            <div class="mt-2"></div>

            <!-- Área de upload - só aparece se NÃO houver preview -->
            <app-upload-file #uploadFile [accept]="'image'" [isMobile]="isMobile" [previewUrl]="logoPreviewUrl"
                [errorSize]="erroTamanhoImagem" [errorType]="erroTipoImagem" [required]="true"
                [requiredError]="showRequiredError" [fileName]="selectedFile?.name || null"
                [previewVariant]="'logo'"
                (fileSelected)="handleManualFileUpload($event)" (removeFile)="removelogo()"
                (fileInvalid)="handleFileInvalid($event)" (fileValid)="handleFileValid()">
            </app-upload-file>

        </div>
    </div>
    <div class="col-12 xl:col-6">

    </div>
</div>
<div class="grid h-full" *ngIf="activeOption == 2">
    <div class="col-12 xl:col-6">
        <div class="card">
            <div class="flex align-items-center justify-content-between mb-2">
                <span class="text-900 text-xl font-semibold">
                    Alteração de senha
                </span>
            </div>
            <div>
                Para realizar a alteração de senha, siga as instruções abaixo.
            </div>
            <div class="col-12 mb-4 mt-4 p-0">
                <label class="w-full ss-g-globalClassLabel">
                    Senha atual
                    <div class="p-inputgroup mt-2">
                        <input type="password" id="title" (ngModelChange)="checkLogin()" pInputText class="w-full"
                            [(ngModel)]="senha_atual">
                    </div>
                    <a class="link-right cursor-pointer" (click)="forgot()"
                        style="float: right; margin-top: 8px;">Esqueci minha
                        senha</a>
                </label>
                <div *ngIf="errorPasswordAtual" class="flex align-items-center justify-content-between mt-2">
                    <!-- Mensagem de Erro à esquerda -->
                    <span class="p-error">
                        A senha atual não é a correta!
                    </span>
                </div>
            </div>
            <div class="col-12 mb-4 mt-4 p-0">
                <label class="w-full ss-g-globalClassLabel">
                    Nova senha
                    <div class="p-inputgroup mt-2">
                        <input type="password" id="title" pInputText class="w-full" [(ngModel)]="nova_senha"
                            (ngModelChange)="checkPassword()">
                    </div>
                    <div class="flex align-items-center justify-content-between mt-2">
                        <!-- Mensagem de Erro à esquerda -->
                        <small *ngIf="errorPassword" class="p-error">
                            A senha deve ter pelo menos 6 caracteres
                        </small>
                    </div>
                </label>
            </div>
            <div class="col-12 mb-4 mt-4 p-0">
                <label class="w-full ss-g-globalClassLabel">
                    Confirmar senha
                    <div class="p-inputgroup mt-2">
                        <input type="password" id="title" pInputText class="w-full" [(ngModel)]="confirm_senha"
                            (ngModelChange)="checkConfirmPassword()">
                    </div>
                    <div class="flex align-items-center justify-content-between mt-2">
                        <!-- Mensagem de Erro à esquerda -->
                        <small *ngIf="errorConfirmPassword" class="p-error">
                            As senhas não coincidem.
                        </small>
                    </div>
                </label>
            </div>
        </div>
    </div>
    <div class="col-12 xl:col-6">

    </div>
</div>
<div class="grid h-full" *ngIf="activeOption == 3">
    <div class="col-12 xl:col-6">
        <div class="shadow-none ">
            <div class="card">
                <div class="flex align-items-center justify-content-between mb-2">
                    <span class="text-900 text-xl font-semibold">
                        Limite e uso
                    </span>
                    <span class="ml-auto">
                        <p-tag [value]="plan" severity="warning"></p-tag>
                    </span>
                </div>
                <div class="mb-4">
                    Acompanhe os limites de sua conta e entenda quando fazer um upgrade ou suas faturas são calculadas.
                </div>
                <label class="w-full ss-g-globalClassLabel">Visualizações</label>
                <div class="mt-4"></div>
                <div style="position: relative; width: 100%;">
                    <div
                        style="position: absolute; left: 0; right: 0; top: -20px; display: flex; justify-content: space-between;">
                        <span>0</span>
                        <span>{{views_total}}</span>
                    </div>
                    <div class="slider-container">
                        <p-slider [(ngModel)]="sliderValueViews" [min]="0" [max]="views_total" [disabled]="true"
                            styleClass="w-full" showTicks="true" [step]="1">
                        </p-slider>
                        <!-- Mostrar valor atual/max ao lado direito -->
                        <div class="custom-tick-label" style="position: absolute; right: 0; top: -20px;">
                            {{ sliderValueViews }}/{{views_total}}
                        </div>
                    </div>
                </div>
                <div class="mt-4">
                    <label class="w-full ss-g-globalClassLabel mt-2">Slicks</label>
                    <div class="mt-4"></div>
                    <div style="position: relative; width: 100%;">
                        <div
                            style="position: absolute; left: 0; right: 0; top: -20px; display: flex; justify-content: space-between;">
                            <span>0</span>
                            <span>{{slicks_total}}</span>
                        </div>
                        <div class="slider-container">
                            <p-slider [(ngModel)]="sliderValueSlicks" [min]="0" [max]="slicks_total" [disabled]="true"
                                styleClass="w-full hide-handle" showTicks="true" [step]="1"></p-slider>
                            <div class="custom-tick-label" style="position: absolute; right: 0; top: -20px;">
                                {{ sliderValueSlicks }}/{{slicks_total}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-4">
                    <label class="w-full ss-g-globalClassLabel mt-2">Feeds</label>
                    <div class="mt-4"></div>
                    <div style="position: relative; width: 100%;">
                        <div
                            style="position: absolute; left: 0; right: 0; top: -20px; display: flex; justify-content: space-between;">
                            <span>0</span>
                            <span>{{feeds_total}}</span>
                        </div>
                        <div class="slider-container">
                            <p-slider [(ngModel)]="sliderValueFeeds" [min]="0" [max]="feeds_total" [disabled]="true"
                                styleClass="w-full hide-handle" showTicks="true" [step]="1"></p-slider>
                            <div class="custom-tick-label" style="position: absolute; right: 0; top: -20px;">
                                {{ sliderValueFeeds }}/{{feeds_total}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="card">
                <div class="flex align-items-center justify-content-between mb-2">
                    <span class="text-900 text-xl font-semibold">
                        Histórico de faturas
                    </span>
                </div>
                <div class="mb-4">
                    Confira seu histórico de cobranças e gerencie seus pagamentos
                </div>
                <!--  -->

                <p-tabView class="ss-history-tabview" [(activeIndex)]="activeHistoryTabIndex">

                    <!-- ===================== -->
                    <!-- STRIPE TAB (se existir) -->
                    <!-- ===================== -->
                    <p-tabPanel *ngIf="providers.includes('stripe')">
                        <ng-template pTemplate="header">
                            <img [src]="stripeIcon" alt="Stripe" class="icon-tab" />
                            <span>Stripe</span>
                        </ng-template>

                        <p-table class="ss-history-table" [value]="stripeRows" [loading]="loadingHistory"
                            dataKey="provider_invoice_id" [expandedRowKeys]="expandedRows" responsiveLayout="scroll"
                            [paginator]="true" [rows]="12" [rowsPerPageOptions]="[12,24]" [showCurrentPageReport]="true"
                            currentPageReportTemplate="Mostrando {first}–{last} de {totalRecords} faturas">

                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 3rem"></th>
                                    <th>Mês</th>
                                    <th>Valor</th>
                                    <th class="ss-col-status">Status</th>
                                    <th class="ss-col-actions">Ações</th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-row let-expanded="expanded">
                                <tr>
                                    <td>
                                        <button pButton type="button" class="p-button-text p-button-sm"
                                            [pRowToggler]="row"
                                            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                            [disabled]="!(row?.lines_summary?.length)">
                                        </button>
                                    </td>

                                    <td>
                                        <div class="flex flex-column">
                                            <span class="font-medium">{{ getHistoryLabelPretty(row) }}</span>
                                            <small class="text-600">{{ getHistoryLabel(row) }}</small>
                                        </div>
                                    </td>

                                    <td>
                                        {{ getHistoryAmount(row) |
                                        currency:getHistoryCurrency(row):'symbol':'1.2-2':'pt-BR' }}
                                    </td>

                                    <td class="ss-col-status">
                                        <div class="flex align-items-center gap-2">
                                            <span class="ss-dot" [ngClass]="'ss-' + getHistoryStatus(row)"></span>
                                            <span class="text-600 text-sm">{{ getHistoryStatusLabel(row) }}</span>
                                        </div>
                                    </td>

                                    <td class="ss-col-actions">
                                        <button pButton type="button" class="p-button-text p-button-sm"
                                            icon="pi pi-external-link" (click)="openInvoice(row)"
                                            [disabled]="!(row?.hosted_invoice_url || row?.invoice_pdf)"
                                            pTooltip="Abrir fatura" tooltipPosition="top">
                                        </button>
                                    </td>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="rowexpansion" let-row>
                                <tr>
                                    <td colspan="5">
                                        <div class="p-3">
                                            <div class="flex justify-content-between align-items-center mb-2">
                                                <div class="font-medium">Detalhes da fatura</div>

                                                <small class="text-600" *ngIf="hasProration(row)">
                                                    Ajuste por mudança de plano (prorrata)
                                                </small>
                                            </div>

                                            <p-table [value]="row.lines_summary" responsiveLayout="scroll">
                                                <ng-template pTemplate="header">
                                <tr>
                                    <th>Descrição</th>
                                    <th style="width: 6rem">Qtd</th>
                                    <th style="width: 10rem">Unitário</th>
                                    <th style="width: 10rem">Valor</th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-line>
                                <tr>
                                    <td>
                                        <div class="flex flex-column">
                                            <span class="font-medium">{{ line.description || '-' }}</span>
                                            <small class="text-600" *ngIf="line.proration">Prorrata</small>
                                        </div>
                                    </td>

                                    <td>{{ line.quantity ?? '-' }}</td>

                                    <td>
                                        <span *ngIf="line.unit_amount != null">
                                            {{ (line.unit_amount/100) | currency: line.currency:'symbol':'1.2-2':'pt-BR'
                                            }}
                                        </span>
                                        <span *ngIf="line.unit_amount == null">-</span>
                                    </td>

                                    <td>
                                        {{ (line.amount/100) | currency: line.currency:'symbol':'1.2-2':'pt-BR' }}
                                    </td>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="4" class="text-600">Sem detalhes para esta fatura.</td>
                                </tr>
                            </ng-template>
                        </p-table>

            </div>
            </td>
            </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5" class="text-600">Nenhuma fatura Stripe encontrada.</td>
                </tr>
            </ng-template>

            </p-table>
            </p-tabPanel>


            <!-- ===================== -->
            <!-- SHOPIFY TAB (se existir) -->
            <!-- ===================== -->
            <p-tabPanel *ngIf="providers.includes('shopify')">
                <ng-template pTemplate="header">
                    <img [src]="shopifyIcon" alt="Shopify" class="icon-tab" />
                    <span>Shopify</span>
                </ng-template>

                <p-table class="ss-history-table" [value]="shopifyRows" [loading]="loadingHistory"
                    dataKey="provider_invoice_id" responsiveLayout="scroll">

                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 3rem"></th>
                            <th>Mês</th>
                            <th class="ss-col-actions">Ações</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>
                                <button pButton type="button" class="p-button-text p-button-sm"
                                    icon="pi pi-chevron-right" disabled>
                                </button>
                            </td>

                            <td>
                                <div class="flex flex-column">
                                    <span class="font-medium">Shopify</span>
                                    <small class="text-600">Abrir no Shopify</small>
                                </div>
                            </td>

                            <td class="ss-col-actions">
                                <button pButton type="button" class="p-button-text p-button-sm"
                                    icon="pi pi-external-link" (click)="openInvoice(row)"
                                    [disabled]="!row?.hosted_invoice_url" pTooltip="Abrir billing"
                                    tooltipPosition="top">
                                </button>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="3" class="text-600">Nenhum histórico Shopify disponível.</td>
                        </tr>
                    </ng-template>

                </p-table>
            </p-tabPanel>

            </p-tabView>


            <!--  -->

        </div>
    </div>
</div>
<div class="col-12 xl:col-6" id="feed_subs">
    <div class="shadow-none ">
        <!-- <div class="card" *ngIf="cards.length > 0"> -->
        <div class="card">
            <div class="flex align-items-center justify-content-between mb-2">
                <span class="text-900 text-xl font-semibold">
                    Dados de pagamento
                </span>
            </div>
            <div class="mb-4">
                Cadastre um cartão de crédito de sua preferência para o pagamento de seu plano de assinatura
            </div>

            <!--  -->
            <div class="flex gap-3 align-items-stretch ss-l-payment-row">
                <!-- ADD CARD -->
                <button type="button"
                    class="ss-card-add flex flex-column align-items-center justify-content-center ss-g-hover-border2"
                    (click)="addCard()">
                    <i class="pi pi-plus ss-card-add-icon"></i>
                </button>

                <!-- CAROUSEL -->
                <div class="flex-1 ss-carousel-wrap">
                    <p-carousel class="ss-carousel" *ngIf="cards.length > 0" [value]="cards"
                        [numVisible]="cards.length >= 2 ? 2 : 1" [numScroll]="1" [circular]="false"
                        [showIndicators]="false" [showNavigators]="true" [loading]="loadingCards" [responsiveOptions]="[
                                    { breakpoint: '1200px', numVisible: 2, numScroll: 1 },
                                    { breakpoint: '960px', numVisible: 1, numScroll: 1 }
                                ]">
                        <ng-template pTemplate="item" let-c>
                            <div class="ss-card-item">

                                <!-- LINHA 1: Bandeira + marca | remover -->
                                <div class="flex align-items-center justify-content-between mb-2">
                                    <div class="flex align-items-center gap-2">
                                        <img class="ss-card-brand-img" [src]="getBrandIcon(c)"
                                            [alt]="getBrandLabel(c)" />
                                        <span class="ss-brand">{{ getBrandLabel(c) }}</span>
                                    </div>

                                    <button type="button" class="p-button p-button-text p-button-rounded p-button-sm"
                                        (click)="confirmRemoveCard(c)">
                                        <i class="pi pi-trash"></i>
                                    </button>
                                </div>

                                <!-- LINHA 2: Número do cartão -->
                                <div class="ss-number mb-2">
                                    {{ getMaskedNumber(c) }}
                                </div>

                                <!-- LINHA 3: Padrão | validade -->
                                <div class="flex align-items-center justify-content-between">
                                    <div class="flex align-items-center gap-2">
                                        <span class="text-600 text-sm">Padrão</span>

                                        <p-inputSwitch [ngModel]="isDefaultCard(c)"
                                            [disabled]="loadingCards || isDefaultCard(c)"
                                            (onChange)="onToggleDefaultCard(c, $event)">
                                        </p-inputSwitch>
                                    </div>

                                    <div class="ss-exp">
                                        expira {{ getExpiry(c) }}
                                    </div>
                                </div>

                            </div>
                        </ng-template>

                    </p-carousel>

                    <div *ngIf="!loadingCards && !cards.length" class="text-600 mt-2">
                         
                    </div>
                </div>
            </div>

            <!--  -->

        </div>


        <div class="flex flex-wrap justify-content-left">
            <div class="sm:col-12 md:col-12 lg:col-12 p-2 ">
                <h2 class="text-900 text-left text-4xl font-bold mb-4">Aumente seu limite de uso</h2>
                <p class="text-600 text-left text-lg mb-4">
                    Escolha um plano que melhor se adeque ao seu negócio.
                </p>
            </div>
        </div>
        <div class="flex flex-wrap justify-content-center">
            <!-- Free Plan -->
            <div class="sm:col-12 md:col-6 lg:col-3 p-2 pricing-card">
                <div class="card border-1 surface-border border-round p-5 flex flex-column h-full">
                    <h3 class="text-900 text-xl font-medium mb-2">Free</h3>
                    <p class="text-600">Plano gratuito com recursos básicos</p>
                    <div class="my-4 border-top-1 border-300"></div>
                    <div class="flex align-items-center">
                        <span class="text-900 font-bold text-2xl">$0</span>
                        <span class="text-600 ml-2">por mês</span>
                    </div>
                    <div class="my-4 border-top-1 border-300"></div>
                    <ul class="list-none p-0 flex-grow-1">
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Integração com Shopify
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Vídeos em todas as páginas do site
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Widgets disponíveis: stories, carrossel, popup, grid e inline
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Compartilhamento via redes sociais ou links específicos
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Dashboard com métricas de performance (Analytics)
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Até {{free_plan_videos_count}} vídeos
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            até {{free_plan_views_count}} views
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Suporte via e-mail
                        </li>
                    </ul>

                </div>
            </div>

            <!-- Starter Plan -->
            <div class="sm:col-12 md:col-6 lg:col-3 p-2 pricing-card">
                <div class="card border-1 surface-border border-round p-5 flex flex-column h-full">
                    <h3 class="text-900 text-xl font-medium mb-2">Starter</h3>
                    <p class="text-600">Plano para pequenos negócios</p>
                    <div class="my-4 border-top-1 border-300"></div>
                    <div class="flex align-items-center">
                        <span class="text-900 font-bold text-2xl">{{starterPlanPrice}}</span>
                        <span class="text-600 ml-2">por mês</span>
                    </div>
                    <div class="my-4 border-top-1 border-300"></div>
                    <ul class="list-none p-0 flex-grow-1">
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Integração com Shopify
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Vídeos em todas as páginas do site
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Widgets disponíveis: stories, carrossel, popup, grid e inline
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Compartilhamento via redes sociais ou links específicos
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Dashboard com métricas de performance (Analytics)
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Até {{starter_plan_videos_count}} vídeos
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            até {{starter_plan_views_count}} views
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            R${{starterPlanViews}}/view adicional
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Suporte via whatsapp
                        </li>
                    </ul>
                    <div class="mt-auto">
                        <p-button *ngIf="userSubType != 1 || !isActiveSubscription" label="Assinar"
                            (click)="createSubscription(1)" class="w-full" [loading]="loadingSub[1]"
                            [disabled]="loadingSub[1]"></p-button>

                        <button *ngIf="userSubType == 1 && shouldShowViewSubscription && platform !== 'shopify'" pButton pRipple label="Ver Assinatura" class="p-button-outlined"
                            (click)="openBillingPortal($event)"></button>
                        <button *ngIf="userSubType == 1 && shouldShowViewSubscription && platform === 'shopify'" pButton pRipple label="Cancelar Assinatura" class="p-button-outlined p-button-danger"
                            (click)="showConfirmDialog()"></button>
                    </div>
                </div>
            </div>

            <!-- Pro Plan (destaque) -->
            <div class="sm:col-12 md:col-6 lg:col-3 p-2 pricing-card">
                <div class="card border-1 surface-border border-round p-5 flex flex-column h-full ">
                    <h3 class="text-xl font-medium mb-2">Pro</h3>
                    <p class="text-600">Plano completo para empresas</p>
                    <div class="my-4 border-top-1 border-300"></div>
                    <div class="flex align-items-center">
                        <span class="font-bold text-2xl">{{proPlanPrice}}</span>
                        <span class="text-600 ml-2">por mês</span>
                    </div>
                    <div class="my-4 border-top-1 border-300"></div>
                    <ul class="list-none p-0 flex-grow-1">
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Integração com Shopify
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Vídeos em todas as páginas do site
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Widgets disponíveis: stories, carrossel, popup, grid e inline
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Compartilhamento via redes sociais ou links específicos
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Dashboard com métricas de performance (Analytics)
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Até {{pro_plan_videos_count}} vídeos
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            até {{pro_plan_views_count}} views
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            R${{proPlanViews}}/view adicional
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Suporte via whatsapp
                        </li>
                    </ul>
                    <div class="mt-auto">
                        <p-button *ngIf="userSubType != 2 || !isActiveSubscription" label="Assinar"
                            (click)="createSubscription(2)" class="w-full" [loading]="loadingSub[2]"
                            [disabled]="loadingSub[2]"></p-button>
                        <!-- <p-button *ngIf="userSubType == 2 && shouldShowViewSubscription" label="Ver Assinatura"
                             class="w-full p-button-outlined"></p-button> -->
                        <button *ngIf="userSubType == 2 && shouldShowViewSubscription && platform !== 'shopify'" pButton pRipple label="Ver Assinatura" class="p-button-outlined"
                            (click)="openBillingPortal($event)"></button>
                        <button *ngIf="userSubType == 2 && shouldShowViewSubscription && platform === 'shopify'" pButton pRipple label="Cancelar Assinatura" class="p-button-outlined p-button-danger"
                            (click)="showConfirmDialog()"></button>
                    </div>
                </div>
            </div>

            <!-- Enterprise Plan -->
            <div class="sm:col-12 md:col-6 lg:col-3 p-2 pricing-card">
                <div class="card border-1 surface-border border-round p-5 flex flex-column h-full">
                    <h3 class="text-900 text-xl font-medium mb-2">Enterprise</h3>
                    <p class="text-600">Solução personalizada para grandes empresas</p>
                    <div class="my-4 border-top-1 border-300"></div>
                    <div class="flex align-items-center">
                        <span class="text-900 font-bold text-2xl">{{enterprisePlanPrice}}</span>
                        <span class="text-600 ml-2">por mês</span>
                    </div>
                    <div class="my-4 border-top-1 border-300"></div>
                    <ul class="list-none p-0 flex-grow-1">
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Integração com Shopify
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Vídeos em todas as páginas do site
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Widgets disponíveis: stories, carrossel, popup, grid e inline
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Compartilhamento via redes sociais ou links específicos
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Dashboard com métricas de performance (Analytics)
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Até {{enterprise_plan_videos_count}} vídeos
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            até {{enterprise_plan_views_count}} views
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            R${{enterprisePlanViews}}/view adicional
                        </li>
                        <li class="flex align-items-center mb-3">
                            <i class="pi pi-check-circle text-primary mr-2"></i>
                            Suporte via call
                        </li>
                    </ul>
                    <div class="mt-auto">
                        <p-button *ngIf="userSubType != 3 || !isActiveSubscription" label="Assinar"
                            (click)="createSubscription(3)" class="w-full" [loading]="loadingSub[3]"
                            [disabled]="loadingSub[3]"></p-button>
                        <!-- <p-button  label="Ver Assinatura"
                            (click)="openBillingPortal($event)" class="w-full p-button-outlined"></p-button> -->
                        <button *ngIf="userSubType == 3 && shouldShowViewSubscription && platform !== 'shopify'" pButton pRipple label="Ver Assinatura" class="p-button-outlined"
                            (click)="openBillingPortal($event)"></button>
                        <button *ngIf="userSubType == 3 && shouldShowViewSubscription && platform === 'shopify'" pButton pRipple label="Cancelar Assinatura" class="p-button-outlined p-button-danger"
                            (click)="showConfirmDialog()"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


</div>



<p-dialog header="Recuperação de Senha" [(visible)]="display" [modal]="true" [style]="{width: '350px'}"
    [baseZIndex]="10000" class="ss-g-dialog-sized">
    <div class="confirmation-content">
        <p>Você receberá um email para recuperar a senha. Deseja continuar?</p>
    </div>
    <p-footer>
        <button type="button" pButton label="Sim" icon="pi pi-check" (click)="confirmForgot()"></button>
        <button type="button" pButton label="Não" icon="pi pi-times" (click)="display=false"
            class="ui-button-secondary"></button>
    </p-footer>
</p-dialog>





<p-sidebar [(visible)]="displaySidebar" (onShow)="handleSidebarOpen()" #sidebar id="ss-l-sideBarBottom" [modal]="false"
    class="ss-g-custom-sidebar-width" position="bottom" [baseZIndex]="1102">
    <ng-template pTemplate="footer">
        <div class="w-full  text-right p-0" *ngIf="activeOption == 1">
            <button pButton pRipple label="Cancelar" (click)="closeSidebar()" class="p-button-outlined mr-2"></button>
            <button pButton pRipple label="Salvar" [disabled]="disableSave" [loading]="loadingBtn"
                (click)="saveProfile()" class="primary"></button>
        </div>
        <div class="w-full  text-right p-0" *ngIf="activeOption == 2">
            <button pButton pRipple label="Cancelar" (click)="closeSidebar()" class="p-button-outlined mr-2"></button>
            <button pButton pRipple label="Salvar" [disabled]="btnSaveSecurity" [loading]="loadingBtnSecurity"
                (click)="changePassword()" class="primary"></button>
        </div>
        <div class="w-full  text-right p-0" *ngIf="activeOption == 3">
            <button pButton pRipple label="Cancelar" (click)="closeSidebar()" class="p-button-outlined mr-2"></button>
            <button pButton pRipple label="Salvar" [disabled]="true" class="primary"></button>
        </div>
    </ng-template>
</p-sidebar>


<p-dialog header="Alterar Email" [(visible)]="showDialog" [modal]="true" [closable]="true" [showHeader]="true"
    [dismissableMask]="true" class="ss-g-dialog-sized">
    <p><input type="text" pInputText class="w-full" [(ngModel)]="newEmail" placeholder="Digite o novo email"
            (ngModelChange)="onEmailChange($event)"></p>
    <div *ngIf="errorEmail" class="flex align-items-center justify-content-between mt-2">
        <!-- Mensagem de Erro à esquerda -->
        <span class="p-error">
            Insira um emal válido
        </span>
    </div>
    <div *ngIf="errorMessage" class="flex align-items-center justify-content-between mt-2">
        <!-- Mensagem de Erro dinâmica -->
        <span class="p-error">
            {{ errorMessage }}
        </span>
    </div>
    <p-footer>
        <button pButton label="Enviar email de confirmação" [disabled]="!isEmailValid || isLoading"
            [loading]="isLoading" class="w-full" icon="pi pi-check" (click)="updateEmail()"></button>
    </p-footer>
</p-dialog>



<app-dialog-aguarde [visible]="displayAguarde"></app-dialog-aguarde>

<p-dialog [(visible)]="confirmDialogVisible" [modal]="true" [closable]="false" class="ss-g-dialog-sized">
    <ng-template pTemplate="header">
        <h3>Confirmar Cancelamento</h3>
    </ng-template>
    <ng-template pTemplate="content">
        <p>Tem certeza que deseja cancelar sua assinatura?</p>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton label="Não" icon="pi pi-times" class="p-button-danger"
            (click)="confirmDialogVisible = false"></button>
        <button pButton label="Sim" icon="pi pi-check" (click)="confirmCancelSubscription()"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Cadastrar cartão" [(visible)]="cardDialogVisible" [modal]="true" [style]="{ width: '520px' }"
    [contentStyle]="{ 'min-height': '320px' }" (onShow)="onCardDialogShow()" (onHide)="onCardDialogHide()"
    class="ss-g-dialog-sized">
    <div class="ss-card-dialog-body">

        <!-- Stripe container sempre presente -->
        <div id="stripe-payment-element"></div>

        <!-- Overlay de loading (centralizado) -->
        <div class="ss-loading-overlay" *ngIf="loadingCard">
            <p-progressSpinner></p-progressSpinner>
        </div>

    </div>

    <div class="flex justify-content-end gap-2 mt-3">
        <button pButton label="Cancelar" class="p-button-text" (click)="cardDialogVisible=false"></button>
        <button pButton label="Salvar cartão" (click)="submitCard()" [disabled]="submitting || loadingCard"></button>
    </div>
</p-dialog>

<!-- Dialog de confirmação de assinatura ativada -->
<p-dialog header="Assinatura ativada!" [(visible)]="invoiceDialogVisible" [modal]="true"
    [baseZIndex]="101" [dismissableMask]="true" [draggable]="false" [resizable]="false"
    [style]="{ width: '420px' }" (onHide)="closeInvoiceDialog()" class="ss-g-dialog-sized">
    <div class="flex flex-column align-items-center gap-3 py-3">
        <i class="pi pi-check-circle text-green-500" style="font-size: 3rem;"></i>
        <p class="text-center m-0">Seu pagamento foi confirmado e a assinatura está ativa.</p>
        <a *ngIf="invoiceUrl" [href]="invoiceUrl" target="_blank"
            class="p-button p-button-text p-button-sm">
            <i class="pi pi-file mr-2"></i> Ver fatura
        </a>
    </div>
    <ng-template pTemplate="footer">
        <div class="text-right">
            <button pButton label="Fechar" icon="pi pi-check" (click)="closeInvoiceDialog()"></button>
        </div>
    </ng-template>
</p-dialog>

<!-- Dialog de pagamento da assinatura -->
<p-dialog header="Confirmar assinatura" [(visible)]="stripePayVisible" [modal]="true"
    [style]="{ width: '520px' }" [contentStyle]="{ 'min-height': '320px' }" class="ss-g-dialog-sized"
    [closable]="!stripePayLoading" [dismissableMask]="false" [draggable]="false" [resizable]="false"
    (onHide)="closeStripePay()">

    <div *ngIf="stripePayPlanName" class="flex align-items-center gap-2 mb-3">
        <span class="font-semibold text-900">{{ stripePayPlanName }}</span>
        <span class="text-600">·</span>
        <span class="font-bold text-primary">{{ stripePayPlanPrice }}/mês</span>
    </div>

    <div id="stripe-subscription-payment-element" class="mb-3"></div>

    <div *ngIf="stripeErrorMsg" class="p-error mb-3">{{ stripeErrorMsg }}</div>

    <div class="flex justify-content-end gap-2 mt-3">
        <button pButton label="Cancelar" class="p-button-text"
            [disabled]="stripePayLoading"
            (click)="closeStripePay()"></button>
        <button pButton label="Pagar e assinar"
            [loading]="stripePayLoading"
            [disabled]="stripePayLoading"
            (click)="confirmStripePayment()"></button>
    </div>
</p-dialog>